export default __webpack_public_path__ + "static/media/s1.1.ea82b4d0.png";